<template>
  <div class="demo-app">
    <b-card
      no-body
      class="calendar-container"
    >
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <b-row>
          <b-col cols="12">
            <div class="calendar-wrapper">
              <div class="calendar-header-custom">
                <b-form-checkbox
                  v-if="isTeacher"
                  v-model="forMeFilter"
                  class="mb-1"
                  @change="handleForMeFilter"
                >
                  Thời khóa biểu của tôi
                </b-form-checkbox>
              </div>
              <FullCalendar
                ref="fullCalendar"
                :options="calendarOptions"
              >
                <template v-slot:eventContent="arg">
                  <div class="event-content">
                    <template v-if="isMonthView(arg.view)">
                      <!-- Hiển thị đơn giản cho chế độ tháng -->
                      <div class="event-title-month">
                        <span>{{ arg.event.title }}</span>
                        <span class="event-class-code-month"><feather-icon
                          icon="HashIcon"
                          size="10"
                          class="event-icon"
                        />{{ arg.event.extendedProps.classCode }} - {{ arg.event.extendedProps.room }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="event-header">
                        <div class="event-time">
                          <feather-icon
                            icon="ClockIcon"
                            size="18"
                            class="feather-icon"
                          />
                          <span>{{ arg.timeText }}</span>
                        </div>
                        <div class="event-title">
                          <feather-icon
                            icon="BookOpenIcon"
                            size="18"
                            class="feather-icon"
                          />
                          <span>{{ arg.event.title }}</span>
                        </div>
                      </div>
                      <div class="event-details">
                        <div
                          v-if="arg.event.extendedProps.teacher"
                          class="event-detail-row"
                        >
                          <feather-icon
                            icon="UserCheckIcon"
                            size="16"
                          />
                          <span class="event-teacher">{{ arg.event.extendedProps.teacher }}</span>
                        </div>
                        <div
                          v-if="arg.event.extendedProps.room"
                          class="event-detail-row"
                        >
                          <feather-icon
                            icon="HomeIcon"
                            size="16"
                          />
                          <span class="event-room">{{ arg.event.extendedProps.room }}</span>
                        </div>
                        <div
                          v-if="arg.event.extendedProps.classCode"
                          class="event-detail-row"
                        >
                          <feather-icon
                            icon="HashIcon"
                            size="16"
                            class="event-icon"
                          />
                          <span class="event-class-code">{{ arg.event.extendedProps.classCode }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </FullCalendar>
            </div>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import viLocale from '@fullcalendar/core/locales/vi'
import {
  BCard, BRow, BCol, BFormCheckbox, BOverlay,
} from 'bootstrap-vue'
import { getUser } from '@/auth/utils'
import API from './apiHome'
import '@/assets/scss/_fullCalendar.scss'

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    FullCalendar,
  },
  data() {
    return {
      isLoading: false,
      turns: [],
      user: getUser(),
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        timeZone: 'Asia/Ho_Chi_Minh',
        weekNumbers: true,
        datesSet: this.handleDatesSet, // Callback để tùy chỉnh tiêu đề
        initialView: 'timeGridWeek',
        allDaySlot: false,
        slotMinTime: '07:00:00',
        slotMaxTime: '22:00:00',
        slotDuration: '00:30:00',
        slotLabelInterval: '01:00:00',
        nowIndicator: true,
        weekends: true,
        firstDay: 1,
        locale: {
          ...viLocale,
          weekText: 'Tuần',
        },
        height: 'auto',
        contentHeight: 'auto',
        selectable: false,
        slotEventOverlap: true,
        eventOverlap: true,
        editable: false,
        eventClick: this.handleEventClick,
        expandRows: false,
        aspectRatio: 1.5,
        eventMinHeight: 20,
        eventDisplay: 'auto',
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        },
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        },
        eventClassNames: 'custom-event-style',
        dayHeaderFormat: {
          weekday: 'long',
          day: 'numeric',
          month: 'numeric',
          separator: ' ngày ',
          omitYear: true,
        },
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        },
        views: {
          dayGridMonth: {
            dayHeaderFormat: { weekday: 'short' },
            titleFormat: {
              year: 'numeric',
              month: '2-digit',
            },
          },
          timeGridWeek: {
            titleFormat: {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            },
          },
          timeGridDay: {
            titleFormat: { day: '2-digit', month: '2-digit', year: 'numeric' },
          },
          eventColor: '#a4bdfc', // Màu mặc định
          eventBackgroundColor: '#a4bdfc',
          eventBorderColor: 'rgba(0, 0, 0, 0.1)',
          eventTextColor: '#333',
        },
        events: [],
        eventDidMount: this.handleEventMount,
      },
      filter: {
        currentPage: 1,
        itemsPerPage: 10000000,
        courseId: '',
        courseSemesterId: '',
        teacherId: '',
      },
      forMeFilter: false,
    }
  },
  computed: {
    isTeacher() {
      return !!this.user.teacherId
    },
  },
  async created() {
    await Promise.all(
      this.fetchTurns(),
      this.fetchSchedule(),
    )
  },
  methods: {
    async handleDatesSet(dateInfo) {
      const { type, title } = dateInfo.view
      if (type === 'timeGridDay') {
        const weekNumber = await API.getWeekByStartDateAndEndDate({
          startDate: dateInfo.startStr.split('T')[0],
          endDate: new Date(dateInfo.end.getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        })
        document.querySelector('.fc-toolbar-title').textContent = `(Tuần ${weekNumber}) ${dateInfo.start.toLocaleDateString('vi', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })}`
      } else if (type === 'timeGridWeek') {
        const weekNumber = await API.getWeekByStartDateAndEndDate({
          startDate: dateInfo.startStr.split('T')[0],
          endDate: new Date(dateInfo.end.getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        })
        document.querySelector('.fc-toolbar-title').textContent = `(Tuần ${weekNumber}) ${dateInfo.start.toLocaleDateString('vi', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })} - ${dateInfo.end.toLocaleDateString('vi', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })}`
      } else {
        document.querySelector('.fc-toolbar-title').textContent = title
      }
    },
    isMonthView(view) {
      return view.type === 'dayGridMonth'
    },

    async handleForMeFilter(event) {
      this.filter.teacherId = this.user && event ? this.user.teacherId : ''
      await this.fetchSchedule()
    },

    getColorByClassCode(classCode) {
      if (!classCode) return '#a4bdfc' // Màu mặc định

      // Tạo hash từ classCode để đảm bảo cùng mã lớp → cùng màu
      let hash = 0
      for (let i = 0; i < classCode.length; i++) {
        hash = classCode.charCodeAt(i) + ((hash << 5) - hash)
      }

      const colors = [
        // Nhóm xanh dương đậm
        '#4c78e6', '#5b85ff', '#6a92ff', '#3f65cc', '#2e52b3', '#1d3f99',
        // Nhóm tím đậm
        '#8a5ce6', '#996aff', '#a878ff', '#7a4ecc', '#693bb3', '#582899',
        // Nhóm hồng/đỏ đậm
        '#cc4e4e', '#db6060', '#ea7272', '#b34141', '#9a3434', '#812727',
        // Nhóm cam đậm
        '#cc8033', '#db8f44', '#ea9e55', '#b36622', '#9a4c11', '#813300',
        // Nhóm xanh lá mạ đậm
        '#3b8742', '#4a9651', '#59a560', '#307838', '#255f2e', '#1a4624',
        // Nhóm nâu đậm
        '#8b5a2b', '#9a693a', '#a97849', '#7a4b22', '#693c1b', '#582d14',
        // Nhóm tím xám đậm
        '#6b5c8a', '#7a6a99', '#8978a8', '#5c4e7a', '#4b3f6b', '#3a305c',
        // Nhóm xám đậm
        '#4a4a4a', '#5c5c5c', '#6e6e6e', '#404040', '#333333', '#262626',
        // Nhóm xám trung tính
        '#808080', '#929292', '#a4a4a4', '#757575', '#666666', '#575757',
        // Nhóm xám tối mới
        '#3c3c3c', '#2e2e2e', '#202020', '#1a1a1a', '#141414', '#0e0e0e',
        // Nhóm xám xanh đậm
        '#4a5c5c', '#596e6e', '#688080', '#3f4e4e', '#333f3f', '#273030',
        // Nhóm xám tím đậm
        '#5c4a5c', '#6b596b', '#7a687a', '#4e3f4e', '#3f303f', '#302130',
      ]

      return colors[Math.abs(hash) % colors.length]
    },

    async fetchTurns() {
      try {
        this.turns = await API.getTurns()
      } catch (error) {
        console.error('Error fetching turns:', error)
      }
    },

    async fetchSchedule() {
      this.isLoading = true
      try {
        const response = await API.getSchedules(this.filter)
        this.processScheduleData(response)
      } catch (error) {
        console.error('Error fetching schedule:', error)
      } finally {
        this.isLoading = false
      }
    },

    processScheduleData(scheduleData) {
      const events = []
      const colorMap = {}

      scheduleData.forEach(item => {
        if (!colorMap[item.creditClassCode]) {
          colorMap[item.creditClassCode] = this.getColorByClassCode(item.creditClassCode)
        }

        const days = item.groupDayIds.split(',').map(Number)
        const turnGroups = item.groupTurnIds.split('|')

        days.forEach((dayId, dayIndex) => {
          const turnIds = turnGroups[dayIndex].split(',').map(Number)

          // Tìm tất cả các nhóm tiết liên tiếp
          const allConsecutiveGroups = this.findAllConsecutiveGroups(turnIds)
          // Tạo event riêng cho mỗi nhóm tiết
          allConsecutiveGroups.forEach(group => {
            if (group.length > 0) {
              const firstTurn = this.turns.find(t => t.id === group[0])
              const lastTurn = this.turns.find(t => t.id === group[group.length - 1])

              if (firstTurn && lastTurn) {
                events.push({
                  title: item.subjectName,
                  daysOfWeek: [dayId],
                  startTime: firstTurn.startAt,
                  endTime: lastTurn.endAt,
                  extendedProps: {
                    teacher: item.teacherName,
                    room: item.roomName,
                    classCode: item.creditClassCode,
                    turnNames: group.map(turnId => this.turns.find(t => t.id === turnId)?.name).filter(Boolean).join(', '),
                    // Thêm các thuộc tính mới để phân biệt
                    subjectCode: item.subjectCode,
                    creditClassId: item.creditClassId,
                  },
                  color: colorMap[item.creditClassCode],
                  textColor: '#fff',
                  startRecur: item.startAt,
                  endRecur: item.endAt,
                })
              }
            }
          })
        })
      })

      this.calendarOptions.events = events
      this.updateCalendarTimeRange()
    },
    // Tìm tất cả các nhóm tiết liên tiếp (kể cả không liền nhau)
    findAllConsecutiveGroups(turnIds) {
      if (!turnIds || turnIds.length === 0) return []

      // Sắp xếp và loại bỏ trùng lặp
      const sortedUniqueTurns = [...new Set(turnIds.map(Number))].sort((a, b) => a - b)
      const result = []
      let currentGroup = [sortedUniqueTurns[0]]

      for (let i = 1; i < sortedUniqueTurns.length; i++) {
        // Nếu tiết hiện tại cách tiết trước >1 thì tạo nhóm mới
        if (sortedUniqueTurns[i] > sortedUniqueTurns[i - 1] + 1) {
          result.push([...currentGroup])
          currentGroup = [sortedUniqueTurns[i]]
        } else {
          currentGroup.push(sortedUniqueTurns[i])
        }
      }

      if (currentGroup.length > 0) {
        result.push(currentGroup)
      }

      return result
    },

    getWeekStartDate(yearWeekCode) {
      const [year, week] = yearWeekCode.split('_w').map(Number)
      const date = new Date(year, 0, 1 + (week - 1) * 7)
      while (date.getDay() !== 1) date.setDate(date.getDate() - 1)
      return date.toISOString().split('T')[0]
    },

    getWeekEndDate(yearWeekCode) {
      const startDate = new Date(this.getWeekStartDate(yearWeekCode))
      startDate.setDate(startDate.getDate() + 7)
      return startDate.toISOString().split('T')[0]
    },

    updateCalendarTimeRange() {
      if (this.turns.length === 0) return

      // Tính toán thời gian bắt đầu sớm nhất và kết thúc muộn nhất
      const startTimes = this.turns.map(t => this.timeToMinutes(t.startAt))
      const endTimes = this.turns.map(t => this.timeToMinutes(t.endAt))

      const minTime = Math.min(...startTimes)
      const maxTime = Math.max(...endTimes)

      // Thêm buffer 30 phút trước/sau
      // this.calendarOptions.slotMinTime = this.minutesToTime(minTime - 30)
      // this.calendarOptions.slotMaxTime = this.minutesToTime(maxTime + 30)
      this.$nextTick(() => {
        const calendarApi = this.$refs.fullCalendar?.getApi()
        if (calendarApi) {
          calendarApi.updateSize()
          calendarApi.render()
        }
      })
    },

    // Hàm hỗ trợ chuyển đổi thời gian
    timeToMinutes(timeStr) {
      const [hours, minutes] = timeStr.split(':').map(Number)
      return hours * 60 + minutes
    },

    minutesToTime(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`
    },

    handleEventClick(info) {
      const formatTime = date => {
        if (!date) return '--:--'
        const adjustedDate = new Date(date.getTime() - (7 * 60 * 60 * 1000))
        return adjustedDate.toLocaleTimeString('vi-VN', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })
      }

      const h = this.$createElement
      const messageVNode = h('div', {}, [
        h('h4', {}, info.event.title),
        h('br'),
        h('p', {}, `Mã lớp: ${info.event.extendedProps.classCode}`),
        h('p', {}, `Tiết: ${info.event.extendedProps.turnNames}`),
        h('p', {}, `Thời gian: ${formatTime(info.event.start)} - ${formatTime(info.event.end)}`),
        h('p', {}, `Phòng: ${info.event.extendedProps.room}`),
        h('p', {}, `Giảng viên: ${info.event.extendedProps.teacher}`),
      ])

      this.$bvModal.msgBoxOk(messageVNode, {
        title: 'Thông tin môn học',
        size: 'sm',
        okVariant: 'primary',
        centered: true,
      })
    },

    handleEventMount(info) {
      info.el.classList.add('custom-event')
      if (info.event.start <= new Date() && info.event.end >= new Date()) {
        info.el.classList.add('current-event')
      }
    },
  },
}
</script>

<style scoped>
.calendar-container {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.calendar-wrapper {
  padding: 20px;
}

.event-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.event-header {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.event-time, .event-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.event-time {
  font-weight: 400;
  font-size: 1.8em;
  color: #fff;
  border-bottom: 1px solid white
}

.event-title {
  font-size: 1.8em;
  font-weight: 400;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-title > .feather-icon {
  flex-shrink: 0; /* Không bị co lại */
}

.event-details {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.event-teacher,
.event-room, .event-class-code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1; /* Chiếm không gian còn lại */
}

/* Đảm bảo icon không bị ẩn */
.event-detail-row > .feather-icon {
  flex-shrink: 0;
}

.event-detail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1.2em;
  line-height: 1.2;
  min-width: 0;
}

.event-room {
  font-weight: 500;
}
.for-me-checkbox {
  margin-right: 5px;
  vertical-align: middle;
}

.fc-customForMeButton-button {
  display: flex;
  align-items: center;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}

.fc-customForMeButton-button:hover {
  background: #f0f0f0 !important;
}
/* Thêm vào phần style */
.event-title-month {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  font-size: 0.9em;
  line-height: 1.2;
}

.event-class-code-month {
  font-size: 0.8em;
  opacity: 0.8;
  font-weight: 500;
}

/* Điều chỉnh cho chế độ tháng */
.fc-dayGridMonth-view .fc-event {
  font-size: 0.9em;
  padding: 1px 2px;
}

.fc-dayGridMonth-view .fc-event .fc-event-main {
  padding: 0;
}

</style>

<style>
.fc .fc-timegrid-slot {
  height: 2.5em;
}

.fc .fc-col-header-cell {
  background-color: #f8f9fa;
  padding: 8px 0;
}

.fc .fc-timegrid-axis {
  background-color: #f8f9fa;
}

.fc .fc-timegrid-event {
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.fc .fc-timegrid-event .fc-event-main {
  padding: 4px;
}

.custom-event-style {
  border-left: 4px solid;
  border-left-color: var(--fc-event-border-color);
  background-color: var(--fc-event-bg-color);
  transition: all 0.2s ease;
}

.custom-event-style:hover {
  filter: brightness(1.1);
  box-shadow: 0 2px 5px rgba(0,0,0,0.15);
}
.fc-event {
  border: 1px solid rgba(0, 0, 0, 0.1); /* Viền mỏng */
  opacity: 0.9;
  transition: all 0.2s ease;
}

.fc-event:hover {
  opacity: 1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.fc-event .fc-event-main {
  padding: 4px;
}

/* Màu chữ tương phản tốt */
.fc-event,
.fc-event a {
  color: #333 !important; /* Chữ màu tối */
  text-decoration: none;
}

.fc .fc-day-sat,
.fc .fc-day-sun {
  background-color: #f9f9f9;
}

.fc-dayGridMonth-view .fc-daygrid-week-number, .fc-timegrid-axis-cushion {
  display: none;
}
</style>
